import {useEffect} from "react";

export default function SEO({title, description, keywords, canonical}) {
    useEffect(() => {
        if (title) document.title = title;

        if (description) {
            let metaDesc = document.querySelector("meta[name='description']");
            if (!metaDesc) {
                metaDesc = document.createElement("meta");
                metaDesc.name = "description";
                document.head.appendChild(metaDesc);
            }
            metaDesc.content = description;
        }

        if (keywords) {
            let metaKeywords = document.querySelector("meta[name='keywords']");
            if (!metaKeywords) {
                metaKeywords = document.createElement("meta");
                metaKeywords.name = "keywords";
                document.head.appendChild(metaKeywords);
            }
            metaKeywords.content = keywords;
        }

        if (canonical) {
            let linkCanonical = document.querySelector("link[rel='canonical']");
            if (!linkCanonical) {
                linkCanonical = document.createElement("link");
                linkCanonical.rel = "canonical";
                document.head.appendChild(linkCanonical);
            }
            linkCanonical.href = canonical;
        }
    }, [title, description, keywords, canonical]);

    return null;
}